/* eslint-disable no-debugger */
import Vue from 'vue';
import API from '@/api';
import Services from '@/config/_axios';
import i18n from '../../config/_i18n';
import { getSuccessServiceMsg, getErrorServiceMsg } from '../../config/serviceMessages';

const qs = require('qs');

const deposit = {
  state: () => ({
    selectedCurrency:
      i18n.locale === 'tr' ? { code: 'TRY', name: 'Türk Lirası' } : { code: 'TRY', name: 'Turkish Liras' },
    userBalance: 0,
    amount: null,
    wallet: [],
    bankList: [],
    selectedBank: null,
    selectedBankCurrency: {
      code: 'TRY',
      name: 'Banka'
    },
    transfer: {},
    isCrypto: false,
    isDeposit: false,
    history: [],
    next: '',
    selectedCountry: null,
    isLoading: true,
    networks: [],
    selectedNetwork: null
  }),
  mutations: {
    IS_LOADING(state, payload) {
      state.isLoading = payload;
    },
    SET_HISTORY(state, payload) {
      state.next = payload.payload.links.next;
      if (!payload.isNextPage) {
        state.history = [];
      }
      for (let idx in payload.payload.data) {
        state.history.push(payload.payload.data[idx]);
      }
    },
    SET_DEPOSIT(state, payload) {
      if (state.selectedCurrency.crypto === true) {
        /* const providers = payload?.data?.crypto_currency?.providers || [];
        if(providers.length > 0) {
          state.wallet = providers[0];
        } */
      } else {
        state.bankList = [];
        state.bankList = payload.data.bank_transfer.providers;
      }
    },
    SET_CURRENCY_BALANCE(state, payload) {
      state.userBalance = payload.data.available_formatted;
    },
    updateSelectedCurrency(state, value) {
      state.selectedCurrency = value;
    },
    updateSelectedBank(state, value) {
      state.selectedBank = value;
      if (value == '8') {
        state.selectedBankCurrency = 'GBP';
      } else {
        state.selectedBankCurrency = 'TRY';
      }
    },
    updateAmount(state, value) {
      state.amount = value;
    },
    CLEAR_DEPOSIT(state) {
      state.amount = null;
      state.selectedBank = null;
    },
    SET_CREATE_DEPOSIT(state, payload) {
      if(!payload) {
        state.isDeposit = false;
        state.transfer = null;
        return
      }
      state.isDeposit = true;
      state.transfer = payload;
    },
    updateSelectedCountry(state, value) {
      state.selectedCountry = value;
    },
    onChangeSelectedNetwork(state, payload) {
      state.selectedNetwork = payload;
      state.wallet = payload;
    },
    SET_WALLET(state, wallets) {
      state.wallet = [];
      state.networks = [];
      state.selectedNetwork = null;
      if(state.selectedCurrency.crypto === true && wallets?.length > 0) {
        if(state.selectedCurrency.code === 'USDT') {
          // set networks
          state.networks = wallets;
          state.selectedNetwork = wallets[0];
        }
        state.wallet = wallets[0];
      }

    }
  },
  actions: {
    GET_HISTORY({ state, commit }, params) {
      let nextPage = `${API.depositHistory}${state.selectedCurrency.code}?page=1`;
      if (params.isNextPage) {
        nextPage = `${state.next}&currency=${state.selectedCurrency.code}`;
      }
      Services.get(nextPage)
        .then(res => {
          let data = {
            payload: res.data,
            isNextPage: params.isNextPage
          };
          commit('SET_HISTORY', data);
          commit('IS_LOADING', false);
        })
        .catch(err => {
          if (err?.response?.data?.message) {
            Vue.$toast.error(getErrorServiceMsg(err.response));
          }
        });
    },
    GET_DEPOSIT_PROVIDERS({ commit }, {currency, country_id}) {
      Services.get(`${API.depositProviders}/${currency}?country_id=${country_id}`)
        .then(res => {
          commit('SET_DEPOSIT', res.data);
          commit('IS_LOADING', false);
        })
        .catch(err => {
          if (err?.response?.data?.message) {
            Vue.$toast.error(getErrorServiceMsg(err.response));
          }
        });
    },

    GET_CURRENCY_BALANCE({ commit }, currency) {
      Services.get(API.currencyBalance + currency)
        .then(res => {
          commit('SET_CURRENCY_BALANCE', res.data);
          commit('SET_WALLET', res.data?.data?.wallets || [])
          commit('IS_LOADING', false);
        })
        .catch(err => {
          if (err?.response?.data?.message) {
            Vue.$toast.error(getErrorServiceMsg(err.response));
          }
        });
    },
    POST_CREATE_DEPOSIT({ state, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('IS_LOADING', true);
        Services.post(
          API.depositCreate,
          qs.stringify({
            provider_id: state.selectedBank.id,
            currency: state.selectedCurrency.code,
            amount: state.amount,
            code: state.transfer.code
          })
        )
          .then(res => {
            resolve(res);
            Vue.$toast.success(getSuccessServiceMsg(res));
            commit('SET_CREATE_DEPOSIT', null);
            commit('CLEAR_DEPOSIT');
            dispatch('GET_HISTORY', { currency: state.selectedCurrency, isNextPage: false });
          })
          .catch(err => {
            reject(err);
            if (err?.response?.data?.message) {
              Vue.$toast.error(getErrorServiceMsg(err.response));
            }
          })
          .finally(() => {
            commit('IS_LOADING', false);
          })
      })
    },
    /**
     * 
     * @param {*} param0 
     * this method is not being used any more 27.10.2022
     */
    PUT_APPROVE_DEPOSIT({ dispatch, state, commit }) {
      commit('IS_LOADING', true);
      Services.put(`${API.depositApprove}${state.transfer.code}`)
        .then(res => {
          commit('SET_CREATE_DEPOSIT', null);
          Vue.$toast.success(getSuccessServiceMsg(res));
          commit('IS_LOADING', false);
          commit('CLEAR_DEPOSIT');
          dispatch('GET_HISTORY', { currency: state.selectedCurrency, isNextPage: false });
        })
        .catch(err => {
          if (err?.response?.data?.message) {
            Vue.$toast.error(getErrorServiceMsg(err.response));
          }
        });
    },
    CANCEL_DEPOSIT({ /* state, dispatch, */ commit }) {
      commit('SET_CREATE_DEPOSIT', null);
      // dispatch('GET_HISTORY', { currency: state.selectedCurrency, isNextPage: false });
    },
    CANCEL_OPERATION({ state, dispatch, commit }, code) {
      Services.delete(`${API.depositCancel}${code}`)
        .then(res => {
          Vue.$toast.success(getSuccessServiceMsg(res));
          dispatch('GET_HISTORY', { currency: state.selectedCurrency, isNextPage: false });
          //location.reload()
          commit('IS_LOADING', false);
        })
        .catch(err => {
          if (err?.response?.data?.message) {
            Vue.$toast.error(getErrorServiceMsg(err.response));
          }
        });
    },
    CONFIRM_OPERATION({ state, dispatch, commit }, code) {
      Services.put(`${API.depositApprove}${code}`)
        .then(res => {
          Vue.$toast.success(getSuccessServiceMsg(res));
          dispatch('GET_HISTORY', { currency: state.selectedCurrency, isNextPage: false });
          //location.reload()
          commit('IS_LOADING', false);
        })
        .catch(err => {
          if (err?.response?.data?.message) {
            Vue.$toast.error(getErrorServiceMsg(err.response));
          }
        });
    },
    FETCH_TRANSFER({ commit }, { provider_id, currency }) {
      commit('IS_LOADING', true);
      Services.post(`${API.depositCreateInfos}`, { provider_id, currency })
        .then(res => {
          commit('IS_LOADING', false);
          commit('SET_CREATE_DEPOSIT', res.data?.data || undefined);
        })
        .catch(err => {
          commit('IS_LOADING', false);
          if (err?.response?.data?.message) {
            Vue.$toast.error(getErrorServiceMsg(err.response));
          }
        })
    }
  },
  getters: {},
  namespaced: true
};

export default deposit;
